module.exports = __webpack_public_path__ + "static/media/CarP.551e795c.png";